import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "../../assets/RenderedAssets";
import TextFade from "../CustomTexts/TextFade";
import { EachHeroServiceItem } from "../../types";

const HeroServiceItem = ({
  bg,
  image,
  title,
  description,
  url,
}: EachHeroServiceItem) => {
  return (
    <TextFade isSpan={true} animation="zoom-in">
      <div
        className="relative overflow-hidden rounded-[20px] md:p-10 p-5 flex flex-col gap-10 text-white bg-cover bg-center"
        style={{
          backgroundImage: `linear-gradient(rgba(255, 102, 0, 0.65), rgba(4, 27, 4, 0.4)), url('${bg}')`,
        }}
      >
        <img src={image} alt="" className="md:w-[190px] w-[120px] animate-float" />
        <h1 className="md:text-[40px] text-[28px] font-bold text-white">
          {title}
        </h1>
        <p className="text-white md:text-[20px] text-[14px]">{description}</p>
        <div className="flex justify-end">
          <Link
            to={url}
            className="text-secondary text-[19px] font-bold uppercase flex gap-2 items-center justify-center w-fit"
          >
            Read More <ArrowRight />
          </Link>
        </div>
      </div>
    </TextFade>
  );
};

export default HeroServiceItem;
